import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ValueStack() {
  const items = ["Guía 'Fast-Track' de Nichos Rentables.", 'Prompts Maestros para que la IA escriba por ti.', 'Sistema de Pago Express Setup.'];
  return <section className="bg-white py-12 md:py-24 px-4" data-id="element-304">
      <div className="max-w-5xl mx-auto" data-id="element-305">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-306">
          <span className="text-primary font-bold uppercase tracking-wider text-sm mb-2 block" data-id="element-307">
            Todo Incluido
          </span>
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline" data-id="element-308">
            Tu Bundle Digital Completo
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-309">
          {/* 3D Device Mockup */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-310">
            <div className="relative flex items-center justify-center" data-id="element-311">
              {/* Tablet */}
              <div className="absolute left-0 top-0 w-64 h-80 bg-gradient-to-br from-slate-800 to-slate-900 rounded-[24px] shadow-2xl border-8 border-slate-700 transform -rotate-6 z-10" data-id="element-312">
                <div className="w-full h-full bg-gradient-to-br from-primary/20 to-cta/20 rounded-[16px] p-6 flex items-center justify-center" data-id="element-313">
                  <div className="text-center" data-id="element-314">
                    <div className="w-16 h-16 bg-white/20 rounded-full mx-auto mb-4 flex items-center justify-center" data-id="element-315">
                      <span className="text-white text-2xl" data-id="element-316">📚</span>
                    </div>
                    <p className="text-white font-bold text-lg" data-id="element-317">
                      Guía Fast-Track
                    </p>
                  </div>
                </div>
              </div>

              {/* Smartphone */}
              <div className="absolute right-0 top-12 w-40 h-72 bg-gradient-to-br from-slate-800 to-slate-900 rounded-[32px] shadow-2xl border-4 border-slate-700 transform rotate-6 z-20" data-id="element-318">
                <div className="w-full h-full bg-gradient-to-br from-purple-500/30 to-pink-500/30 rounded-[28px] p-4 flex items-center justify-center" data-id="element-319">
                  <div className="text-center" data-id="element-320">
                    <div className="w-12 h-12 bg-white/20 rounded-full mx-auto mb-3 flex items-center justify-center" data-id="element-321">
                      <span className="text-white text-xl" data-id="element-322">🤖</span>
                    </div>
                    <p className="text-white font-bold text-sm" data-id="element-323">
                      Prompts de IA
                    </p>
                  </div>
                </div>
              </div>

              {/* Checklist Document */}
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-48 h-56 bg-white rounded-[16px] shadow-xl border border-border transform rotate-3 z-30" data-id="element-324">
                <div className="p-4" data-id="element-325">
                  <div className="flex items-center gap-2 mb-3 pb-2 border-b border-border" data-id="element-326">
                    <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-327"></div>
                    <div className="w-2 h-2 rounded-full bg-yellow-500" data-id="element-328"></div>
                    <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-329"></div>
                  </div>
                  <div className="space-y-2" data-id="element-330">
                    {[1, 2, 3, 4, 5].map(i => <div key={i} className="flex items-center gap-2" data-id="element-331">
                        <CheckCircle2 className="w-4 h-4 text-primary" data-id="element-332" />
                        <div className="h-2 bg-slate-200 rounded flex-1" data-id="element-333"></div>
                      </div>)}
                  </div>
                  <p className="text-center text-xs font-bold text-dark mt-4" data-id="element-334">
                    Setup Express
                  </p>
                </div>
              </div>
            </div>
            <div className="h-96" data-id="element-335"></div>
          </motion.div>

          {/* Bullet Points */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-336">
            {items.map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-4 bg-light rounded-[20px] p-6 border border-border hover:shadow-lg transition-shadow" data-id="element-337">
                <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center" data-id="element-338">
                  <CheckCircle2 className="w-5 h-5 text-primary" data-id="element-339" />
                </div>
                <p className="text-lg md:text-xl text-dark font-medium leading-relaxed" data-id="element-340">
                  {item}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}